import * as React from 'react';
import { DateTimeFormatterOptions, DateTypes, useDateTimeFormatter } from '../../utils/dateFormatters';
import { BpDesignSystem } from '../../types';
import { Box } from '../Box/Box';

export type DateTimeFormatterExtendedProps = BpDesignSystem.Props<
  DateTimeFormatterOptions & {
    date?: DateTypes;
    id?: string;
    div?: WrapDateInDiv;
  }
>;

type WrapDateInDiv = boolean;

/**
 * Simple wrapper around the useDateTimeFormatter hook. Allows hook
 * be used like a React component supporting all the same properties.
 *
 * For example:
 *
 * <DateTimeFormatter format={DateTimeFormats.LONG_DAY_MONTH} includeTime useLong />
 *
 * Use the 'div' prop to wrap the date in a div instead of a span.
 *
 * Can be used as a Styled Component.
 *
 */
export const DateTimeFormatter: React.FC<DateTimeFormatterExtendedProps> = ({
  dataTest,
  style,
  sx,
  date,
  id,
  className,
  div,
  ...props
}) => {
  const { dateTimeFormatter } = useDateTimeFormatter();
  const formattedDate = dateTimeFormatter(date, { ...props });

  return (
    <Box component={div ? 'div' : 'span'} dataTest={dataTest} id={id} className={className} style={style} sx={sx}>
      {formattedDate}
    </Box>
  );
};
